var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 420.8 420.8",
    style: {
      enableBackground: "new 0 0 420.8 420.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;fill:none;stroke:#000000;stroke-width:9;stroke-miterlimit:10;}\n\t.st3{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M144.3,276.5h132.2V144.3H144.3V276.5z M153.7,153.7H267V267H153.7V153.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M210.4,68.7c-78.1,0-141.7,63.6-141.7,141.7s63.6,141.7,141.7,141.7s141.7-63.6,141.7-141.7S288.5,68.7,210.4,68.7z  M210.4,342.6c-72.9,0-132.2-59.3-132.2-132.2S137.5,78.2,210.4,78.2s132.2,59.3,132.2,132.2S283.3,342.6,210.4,342.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    className: "st2",
    cx: 210.4,
    cy: 210.4,
    r: 137.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    className: "st2",
    cx: 210.4,
    cy: 210.4,
    r: 103.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_3_\\uC0AC\\uBCF8"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M210.4,352.5c-78.4,0-142.1-63.8-142.1-142.1C68.3,132,132,68.3,210.4,68.3c78.4,0,142.1,63.8,142.1,142.1 C352.5,288.8,288.8,352.5,210.4,352.5z M210.4,77.3C137,77.3,77.3,137,77.3,210.4S137,343.5,210.4,343.5s133.1-59.7,133.1-133.1 S283.8,77.3,210.4,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st3",
    d: "M205.9,111.8c-52.3,2.4-94.2,45.7-94.2,98.6c0,25.6,9.8,49,25.8,66.5l68.4-68.4V111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st3",
    d: "M143.9,283.3c17.6,16,40.9,25.8,66.5,25.8c54.4,0,98.7-44.3,98.7-98.7c0-52.9-41.9-96.2-94.2-98.6v100.5 L143.9,283.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M214.9,102.8v9c52.3,2.4,94.2,45.7,94.2,98.6c0,54.4-44.3,98.7-98.7,98.7c-25.6,0-49-9.8-66.5-25.8l-6.4,6.4 c19.2,17.7,44.8,28.5,72.9,28.5c59.4,0,107.7-48.3,107.7-107.7C318.1,152.5,272.2,105.2,214.9,102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M205.9,111.8v96.7l-68.4,68.4c2,2.2,4.1,4.3,6.4,6.4l71-71V111.8c-1.5-0.1-3-0.1-4.5-0.1 C208.9,111.7,207.4,111.7,205.9,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M137.5,276.9l-6.4,6.4c2,2.2,4.2,4.3,6.4,6.4l6.4-6.4C141.7,281.2,139.6,279.1,137.5,276.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M210.4,111.7c1.5,0,3,0,4.5,0.1v-9c-1.5-0.1-3-0.1-4.5-0.1c-1.5,0-3,0-4.5,0.1v9C207.4,111.7,208.9,111.7,210.4,111.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.e4baf375.svg";
export { ForwardRef as ReactComponent };